export enum ExportBehavior {
	AllRecordsIntoOneFile = 0,
	OneRecordPerFile = 1,
}
